import { render } from "./ProfileItem.vue?vue&type=template&id=02e81014&scoped=true"
import script from "./ProfileItem.vue?vue&type=script&lang=js"
export * from "./ProfileItem.vue?vue&type=script&lang=js"

import "./ProfileItem.vue?vue&type=style&index=0&id=02e81014&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e81014"],['__file',"src/components/profile/ProfileItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "02e81014"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02e81014', __exports__)) {
    console.log('reload')
    api.reload('02e81014', __exports__)
  }
  
  module.hot.accept("./ProfileItem.vue?vue&type=template&id=02e81014&scoped=true", () => {
    console.log('re-render')
    api.rerender('02e81014', render)
  })

}


export default __exports__